import React from 'react';
import { PenTool as Tool, Calendar, AlertTriangle, Battery, CheckCircle } from 'lucide-react';

interface Equipment {
  id: string;
  name: string;
  type: string;
  purchaseDate: string;
  lastServiced: string;
  nextService: string;
  status: 'available' | 'in_use' | 'maintenance' | 'repair';
  condition: 'excellent' | 'good' | 'fair' | 'poor';
  serialNumber: string;
  cost: number;
}

const mockEquipment: Equipment[] = [
  {
    id: '1',
    name: 'DeWalt Power Drill',
    type: 'Power Tool',
    purchaseDate: '2023-08-15',
    lastServiced: '2024-02-01',
    nextService: '2024-05-01',
    status: 'available',
    condition: 'good',
    serialNumber: 'DW123456',
    cost: 299.99,
  },
  {
    id: '2',
    name: 'Milwaukee Circular Saw',
    type: 'Power Tool',
    purchaseDate: '2023-10-20',
    lastServiced: '2024-01-15',
    nextService: '2024-04-15',
    status: 'in_use',
    condition: 'excellent',
    serialNumber: 'MS789012',
    cost: 449.99,
  },
];

export function EquipmentManager() {
  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 border-b border-gray-200">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-900">Equipment</h2>
          <button className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors flex items-center gap-2">
            <Tool className="h-4 w-4" />
            Add Equipment
          </button>
        </div>
      </div>
      <div className="p-6">
        <div className="space-y-4">
          {mockEquipment.map(item => (
            <div key={item.id} className="border rounded-lg p-4 hover:bg-gray-50">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="text-lg font-medium text-gray-900">{item.name}</h3>
                  <p className="text-sm text-gray-500">{item.type}</p>
                  <p className="text-xs text-gray-400">SN: {item.serialNumber}</p>
                </div>
                <span
                  className={`px-2 py-1 text-xs font-semibold rounded-full
                  ${item.status === 'available' ? 'bg-green-100 text-green-800' : ''}
                  ${item.status === 'in_use' ? 'bg-blue-100 text-blue-800' : ''}
                  ${item.status === 'maintenance' ? 'bg-yellow-100 text-yellow-800' : ''}
                  ${item.status === 'repair' ? 'bg-red-100 text-red-800' : ''}
                `}
                >
                  {item.status.replace('_', ' ').charAt(0).toUpperCase() + item.status.slice(1)}
                </span>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-4">
                <div className="flex items-center gap-2">
                  <Calendar className="h-4 w-4 text-gray-400" />
                  <div>
                    <p className="text-xs text-gray-500">Next Service</p>
                    <p className="text-sm text-gray-600">{item.nextService}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <Battery className="h-4 w-4 text-gray-400" />
                  <div>
                    <p className="text-xs text-gray-500">Condition</p>
                    <p className="text-sm text-gray-600">
                      {item.condition.charAt(0).toUpperCase() + item.condition.slice(1)}
                    </p>
                  </div>
                </div>
              </div>
              {new Date(item.nextService) <= new Date() && (
                <div className="mt-3 flex items-center gap-2 text-yellow-700 bg-yellow-50 p-2 rounded">
                  <AlertTriangle className="h-4 w-4" />
                  <span className="text-sm">Service due</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
